module.exports = __webpack_public_path__ + "static/media/styledDatepicker-Chevrom-Right-black.ee300b79.svg";